import http from 'plugins/axios';

export default {
    groupList(data) {
        return http.get({
            url: '/admin/email/group/list',
            data
        })
    },
    save(data) {
        return http.post({
            url: '/admin/email/group/save',
            data,
            dataType: 'form'
        })
    },
    update(data) {
        return http.post({
            url: '/admin/email/group/user/email/group/update',
            data,
            dataType: 'form'
        })
    },
    removeUser(data) {
        return http.post({
            url: '/admin/email/group/user/email/group/removeUser',
            data,
            dataType: 'form'
        })
    },
    addUser(data) {
        return http.post({
            url: '/admin/email/group/user/email/group/addUser',
            data,
            dataType: 'form'
        })
    },
    getUsers(data) {
        return http.get({
            url: '/admin/email/group/user/email/group/users',
            data
        })
    },
};

// ,
//
